// removed by extract-text-webpack-plugin
module.exports = {"mark-picker":"mark-picker__mark-picker___yXHzN","mark-picker-any":"mark-picker__mark-picker-any___1-K2q"};